export default {
  cashbox: {
    width: 80,
    height: 36
  },
  tableContainer: {
    flex: 1,
    marginBottom: 100
  },
  tBody: {
    maxHeight: '65vh',
    overflow: 'auto'
  }
}
